// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-module--logo--1JYHP","item":"logo-module--item--i8raR","logo__title":"logo-module--logo__title--2kzaY"};